import { t } from "i18next";
import { useEffect } from "react";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { useScreenStore } from "../../../stores/ScreenStore";
import { ScreenType } from "../../../types/types";
import { Separator } from "../../../ui/Separator";
import { VerticalTabs, VerticalTabsContent, VerticalTabsList, VerticalTabsTrigger } from "../../../ui/Tabs/VerticalTabs";
import ScreenEquipmentTab from "./editTabs/ScreenEquipmentTab";
import ScreenSettingsTab from "./editTabs/ScreenSettingsTab";
import ScreenShiftsTab from "./editTabs/ScreenShiftsTab";
import ScreenUsersTab from "./editTabs/ScreenUsersTab";

const MonitorEdit = () => {
  const {screens, setScreens} = useAppStore()
  const {monitor, setMonitor} = useScreenStore()
  const [{ response, isLoading, error }, doFetchCurrentItem] = useFetch(`/directories/screens/${monitor?.id}`);

  function updateScreenInfo() {
    doFetchCurrentItem()
  }

  useEffect(() => {
    if(!response) { return }
    const responseData = response.data as unknown as ScreenType;
    setMonitor(responseData);
    let nScreens: ScreenType[] = screens?.map(s => {
      if(s.id === responseData.id) {
        return responseData
      }
      return s
    })!
    setScreens(nScreens)
  },[response])

  return (
    <>
      <VerticalTabs defaultValue={"settings"} orientation="vertical" className="flex bg-background rounded relative h-full m-6 overflow-hidden">
        <VerticalTabsList className="flex-none">
          <VerticalTabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="settings">
            {t("common_info")}
          </VerticalTabsTrigger>
          <VerticalTabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="equipment">
            {t("equipment")}
          </VerticalTabsTrigger>
          <VerticalTabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="participants">
            {t("participants")}
          </VerticalTabsTrigger>
          <VerticalTabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="shifts">
            {t("shifts")}
          </VerticalTabsTrigger>
        </VerticalTabsList>
        <Separator orientation="vertical"/>
        <div className="flex flex-col w-full h-full justify-start relative overflow-hidden">
          <VerticalTabsContent className="flex flex-col max-w-[1008px] w-full data-[state=active]:h-full" value="settings">
            <ScreenSettingsTab updateMonitor={updateScreenInfo}/>
          </VerticalTabsContent>
          <VerticalTabsContent className="flex flex-col max-w-[1008px] w-full data-[state=active]:h-full" value="equipment">
            <ScreenEquipmentTab updateMonitor={updateScreenInfo}/>
          </VerticalTabsContent>
          <VerticalTabsContent className="flex flex-col max-w-[1008px] w-full data-[state=active]:h-full" value="participants">
            <ScreenUsersTab updateMonitor={updateScreenInfo}/>
          </VerticalTabsContent>
          <VerticalTabsContent className="flex flex-col max-w-[1008px] w-full data-[state=active]:h-full" value="shifts">
            <ScreenShiftsTab updateMonitor={updateScreenInfo}/>
          </VerticalTabsContent>
        </div>
      </VerticalTabs>
    </>
  );
};

export default MonitorEdit;
